<ol
    role="list"
    class="m-0 flex list-none flex-col p-0"
    [attr.aria-label]="'artemisApp.hyperion.generation.run.progressTitle' | artemisTranslate"
    data-testid="hyperion-run-progress"
>
    @for (step of steps(); track step.key) {
        <jhi-hyperion-stage [state]="step.state" [label]="step.labelKey | artemisTranslate" [attr.data-stage]="step.key" [attr.data-state]="step.state">
            <!--
                Before the substeps rather than after them: this is the stage's own clock, and a duration printed under the
                last substep reads as that substep's, which is wrong whenever the substep it lands under has not started.
            -->
            @if (timings()[step.key] || step.summaryKey) {
                <!--
                    Not announced: the running stage's duration counts up once a second, and a live region here would
                    read the whole ladder aloud every second.
                -->
                <p class="m-0 flex flex-wrap items-baseline gap-x-2 tabular-nums text-muted-color" [class.text-xs]="compact()" [class.text-sm]="!compact()" aria-live="off">
                    @if (timings()[step.key]; as timing) {
                        <span data-testid="hyperion-run-stage-time" [attr.data-live]="timing.live">{{ timing.key | artemisTranslate: { duration: timing.duration } }}</span>
                    }
                    @if (step.summaryKey; as summaryKey) {
                        <span data-testid="hyperion-run-stage-summary">{{ summaryKey | artemisTranslate: step.summaryParams }}</span>
                    }
                </p>
            }

            @if (step.substeps; as substeps) {
                <!-- The same visual language one level down, so the pieces of the design stage read as part of it. -->
                <ol role="list" class="mt-1 mb-0 flex list-none flex-col p-0" [attr.aria-label]="step.labelKey | artemisTranslate" data-testid="hyperion-run-substeps">
                    @for (substep of substeps; track substep.key) {
                        <jhi-hyperion-stage
                            [state]="substep.state"
                            [label]="substep.labelKey | artemisTranslate"
                            [attr.data-substep]="substep.key"
                            [attr.data-state]="substep.state"
                        />
                    }
                </ol>
            }

            @if (step.detail) {
                <!--
                    Ruled off when the stage has substeps: what the agent is doing belongs to the stage, and without the rule
                    it butts up against the last substep in the list and reads as that one's.
                -->
                <!--
                    The rule is drawn from the TUM AET UI border token rather than from a bare `border-t` utility: with
                    Tailwind preflight disabled, the bare utility inherits a `border-color` that resolves to
                    `currentColor` in this build, so a hairline meant to be 1.24:1 in dark renders at 17.63:1.
                -->
                <div [class.mt-3]="step.detailRuled" [class.hyperion-stage-rule]="step.detailRuled" [class.pt-3]="step.detailRuled">
                    <!-- One live region for the whole ladder: it sits on the current step, and only one step is ever current. -->
                    <div role="status" class="text-sm text-muted-color">
                        @if (liveMessage(); as message) {
                            <p class="m-0 wrap-anywhere">{{ message }}</p>
                        }
                        @if (visibleRepairRound(); as round) {
                            <p class="mt-1 mb-0 wrap-anywhere" data-testid="hyperion-run-repair-round">
                                {{
                                    'artemisApp.hyperion.generation.live.repairRound'
                                        | artemisTranslate
                                            : {
                                                  round: round.round,
                                                  blocking: round.blocking,
                                                  advisory: round.advisory,
                                                  carriedOver: round.carriedOver,
                                                  drained: round.drained,
                                                  fresh: round.fresh,
                                              }
                                }}
                            </p>
                        }
                    </div>

                    @if (activity(); as view) {
                        <!-- Outside the live region above: its clock ticks every second and must not be announced. -->
                        <jhi-hyperion-run-activity
                            [view]="view"
                            [density]="density()"
                            [cancelAvailable]="cancelAvailable()"
                            [cancelPending]="cancelPending()"
                            [connected]="connected()"
                            (cancelRequested)="cancelRequested.emit()"
                        />
                    }
                </div>
            }
        </jhi-hyperion-stage>
    }
</ol>
